// File: src/pages/Withdrawals.jsx
import { useEffect, useState } from "react";
import api from "../api";

export default function Withdrawals({ token, userInfo }) {
  const [trades, setTrades] = useState([]);
  const [selectedTradeId, setSelectedTradeId] = useState("");
  const [withdrawalAddress, setWithdrawalAddress] = useState("");
  const [withdrawals, setWithdrawals] = useState([]);
  const [busy, setBusy] = useState(false);

  /* ──────────────────────────────────────────────────────────────
     load trades + prior withdrawals once auth info is present
  ────────────────────────────────────────────────────────────── */
  useEffect(() => {
    if (token && userInfo?.id) {
      fetchTrades();
      fetchWithdrawals();
    }
  }, [token, userInfo]);

  const fetchTrades = async () => {
    try {
      const { data } = await api.get("/trades", {
        params: { user_id: userInfo.id },
      });
      setTrades(data);
    } catch (err) {
      console.error("Error fetching trades", err);
      alert("Failed to fetch trades");
    }
  };

  const fetchWithdrawals = async () => {
    try {
      const { data } = await api.get("/withdrawals", {
        params: { user_id: userInfo.id },
      });
      setWithdrawals(data);
    } catch (err) {
      console.error("Error fetching withdrawals", err);
      alert("Failed to fetch withdrawals");
    }
  };

  /* ──────────────────────────────────────────────────────────────
     create new withdrawal
  ────────────────────────────────────────────────────────────── */
  const handleCreateWithdrawal = async () => {
    if (!selectedTradeId || !withdrawalAddress.trim()) {
      return alert("Select a trade and enter an address first.");
    }

    setBusy(true);
    try {
      await api.post("/withdrawals", {
        trade_id: parseInt(selectedTradeId, 10),
        address: withdrawalAddress.trim(),
        btc_amt: 0, // ignored when trade_id present
      });

      alert("Withdrawal submitted!");
      setWithdrawalAddress("");
      setSelectedTradeId("");
      fetchWithdrawals();
    } catch (err) {
      console.error("Error creating withdrawal", err);
      const msg = err.response?.data?.detail || "Error creating withdrawal";
      alert(msg);
    } finally {
      setBusy(false);
    }
  };

  /* ──────────────────────────────────────────────────────────────
     UI
  ────────────────────────────────────────────────────────────── */
  return (
    <div>
      <h2>Submit Withdrawal</h2>

      <select
        value={selectedTradeId}
        onChange={(e) => setSelectedTradeId(e.target.value)}
      >
        <option value="">-- Select Trade --</option>
        {trades.map((t) => (
          <option key={t.id} value={t.id}>
            {new Date(t.executed_at).toLocaleString()} — {t.btc_amt} BTC
          </option>
        ))}
      </select>

      <br />
      <br />

      <input
        type="text"
        placeholder="BTC address"
        value={withdrawalAddress}
        onChange={(e) => setWithdrawalAddress(e.target.value)}
        style={{ width: "100%" }}
      />

      <br />
      <br />

      <button onClick={handleCreateWithdrawal} disabled={busy}>
        {busy ? "Submitting…" : "Submit Withdrawal"}
      </button>

      {withdrawals.length > 0 && (
        <div style={{ marginTop: "2rem" }}>
          <h3>Withdrawals</h3>
          <table border="1" cellPadding="8">
            <thead>
              <tr>
                <th>Date</th>
                <th>Trade&nbsp;ID</th>
                <th>Address</th>
                <th>Status</th>
                <th>TxID</th>
              </tr>
            </thead>
            <tbody>
              {withdrawals.map((w) => (
                <tr key={w.id}>
                  <td>{new Date(w.created_at).toLocaleString()}</td>
                  <td>{w.trade_id ?? "—"}</td>
                  <td>{w.address}</td>
                  <td>{w.status}</td>
                  <td>{w.txid || "—"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
